import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { SequencerDevice } from '@repo/sdk/models/components';

import { useCurrentFacility } from '@/hooks/use-current-facility';
import { useGaiaClient } from '@/hooks/use-gaia-client';
import { getDeviceControlPointIdMapQuery } from '@/queries/gaia-api/get-device-control-point-id-map-query';
import { getSequencerDevicesQuery } from '@/queries/gaia-api/get-sequencer-devices-query';

export const useGetDeviceControlPointIDMap = (): UseQueryResult<
  { [k: string]: Array<string> } | undefined
> => {
  const client = useGaiaClient();
  const { agentId } = useCurrentFacility();
  return useQuery(getDeviceControlPointIdMapQuery({ agentId, client }));
};

export const useGetSequencerDevices = (): UseQueryResult<SequencerDevice[] | undefined> => {
  const client = useGaiaClient();
  const { agentId } = useCurrentFacility();
  return useQuery(getSequencerDevicesQuery({ agentId, client }));
};
